import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

interface IGetCalculatedPercent {
  netNdp: ActualsValueTypes
  currency: string
}

export const getCalculatedPercentValueDependOnSettings =
  <T>({ currency, netNdp }: IGetCalculatedPercent) =>
  (el: T, fields: string[]) => {
    const currencyType = currency === 'USD' ? 'USD' : 'LocalCurrency'
    const postFix = `${netNdp}${currencyType}`
    const field = fields.find((el) => el.endsWith(postFix))
    return field ? el[field] : 0
  }
